/* unplugin-vue-components disabled */import script from "./index.vue?vue&type=script&setup=true&lang=ts"
export * from "./index.vue?vue&type=script&setup=true&lang=ts"

import "./index.vue?vue&type=style&index=0&id=419c8894&lang=less&scoped=true"

import exportComponent from "/Users/liao/work/cmge/ultrasdk/ultrasdk.hub.web/node_modules/.pnpm/vue-loader@16.8.3_@vue+compiler-sfc@3.4.21_vue@3.4.21_webpack@4.47.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-419c8894"]])

export default __exports__